<template>
  <div class="main-view">
    <div class="section shadow filter__wrap">
      <el-form ref="elFormDom" inline :model="table.params" size="mini" @submit.native.prevent>
        <el-form-item label="分类名称:" prop="keyword">
          <el-input clearable v-model="table.params.keyword" placeholder="请输入分类名称" @keydown.enter.native="onSearch"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button class="theneBtn" type="primary" icon="el-icon-search" @click="onSearch">查询 </el-button>
          <el-button @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
      <el-button size="mini" type="primary" plain icon="el-icon-plus" @click="showEdit">添加</el-button>
    </div>

    <VTable
      has-pagionation
      title=''
      addText='添加'
      :field="field"
      :loading="table.loading"
      :data="table.data"
      :page='table.params.page'
      :pageSize='table.params.count'
      :total='table.total'
      :hasPagionation="true"
      :default-expand-all="true"
      :showOverflowTooltip="true"
      :showSelect="false"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    >
      <template v-slot:service_rate="{row}">
        <span>{{row.service_rate}}%</span>
      </template>
      <template v-slot:user_rate="{row}">
        <span>{{row.user_rate}}%</span>
      </template>
      <template v-slot:is_certificate="{row}">
        <span>{{{1:'涉及',2:'不涉及'}[row.is_certificate]}}</span>
      </template>
      <template v-slot:worker_rate="{row}">
        <span>{{row.worker_rate}}%</span>
      </template>
      <template v-slot:rate="{row}">
        <span>{{row.rate}}%</span>
      </template>
      <template v-slot:image="{row}">
        <el-image
          v-if="!!row.image"
          style="width: 40px; height: 40px; line-height: 30px;"
          :src="row.image"
          fit="cover"
          :preview-src-list="[row.image]">
        </el-image>
      </template>
      <!-- <template v-slot:is_multi="{row}">
        <span>{{row.is_multi == 1 ? '多人模式' : '单人模式'}}</span>
      </template> -->
      <template v-slot:status="{row}">
        <el-switch
          v-model="row.status"
          active-color="#13ce66"
          inactive-color="#ff4949"
          :active-value="1"
          :inactive-value="2"
          @change="handleStatus(row)">
        </el-switch>
      </template>
      <template v-slot:action="{row}">
        <el-button type="text" icon="el-icon-edit" @click="showEdit(row)">编辑</el-button>
        <el-button type="text" icon="el-icon-delete" @click="remove(row)">删除</el-button>
      </template>
    </VTable>

    <edit ref="edit" @refresh="getTable"></edit>
    <detail ref="detail"></detail>
    
  </div>
</template>

<script>
import VTable from '@/components/VTable';
import Edit from './components/Edit.vue';
import Detail from './components/Detail.vue';
import { mixinTable } from '@/mixins/table.js';
export default {
  name: 'BannerList',
  components: {
    VTable,
    Edit,
    Detail
  },
  mixins: [mixinTable],
  data() {
    return {
      field: [
        { name: "name", label: "分类名称", hidden: false },
        { name: "image", label: "图标", hidden: false },
        { name: "is_certificate", label: "技能证书", hidden: false },
        { name: "sort", label: "排序", hidden: false },
        { name: "count", label: "二级类目数量", hidden: false },
        // { name: "is_multi", label: "接单模式", hidden: false },
        { name: "service_rate", label: "服务方收益", hidden: false },
        { name: "user_rate", label: "代理邀请用户", hidden: false },
        { name: "worker_rate", label: "代理邀请师傅", hidden: false },
        { name: "rate", label: "代理区域", hidden: false },
        { name: "status", label: "状态", hidden: false },
        { name: "create_time", label: "添加时间",width: "220", hidden: false },
        { name: "action", label: "操作", fixed:"right", width: "140", hidden: false }
      ],
      table: {
        loading: false,
        params: {
          keyword: '',
          parent_id:'',
          type: 1, // 级别 1:一级 2:二级
          page: 1,
          count: 10
        },
        data: [],
        total: 0,
      }
    }
  },
  created() {
    this.getTable();
  },
  methods: {
    getTable() {
      this.$http.get('/admin/flex_kind/list', { params:this.table.params }).then(res => {
        if(res.code === 1) {
          this.table.data = res.data.list;
          this.table.total = res.data.total;
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    showEdit(row) {
      let dom = this.$refs.edit
      dom.toggle(true)
      if (!!row.id) {
        dom.getDetail(row)
      }
      dom = null
    },
    // 查看
    showDetail(row) {
      let dom = this.$refs.detail
      dom.toggle(true)
      dom.getDetail(row)
      dom = null
    },
    // 删除
    remove(row) {
      this.$confirm("是否删除此条记录？", "删除", {
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            this.delete(row.id);
            done()
          } else {
            done()
          }
        }
      }).catch(() => {})
    },
    delete(rowid) {
      this.$http.post('/admin/flex_kind/delete', { id: rowid }).then(res => {
        if(res.code === 1) {
          this.$message.success('操作成功！')
          this.getTable();
        } else {
          this.$message.error(res.data)
        }
      })
    },
    // 切换状态
    handleStatus(row) {
      let _params = {
        id: row.id,
        status:row.status,
        name: row.name,
        sort: row.sort,
        image: row.image,
        // is_multi: row.is_multi,
      }
      this.$http.post('/admin/flex_kind/edit', _params).then(res => {
        if(res.code === 1) {
          this.$message.success('操作成功！')
        } else {
          this.$message.error(res.data)
        }
      }).finally(() => {
        this.getTable();
      })
    }
  }
}
</script>